import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Calculator from "./pages/Calculator";
import AdminLeads from "./pages/AdminLeads";
import AdminPricing from "./pages/AdminPricing";
import Login from "./pages/Login";
import Nav from "./components/Nav";
import { useEffect, useState } from "react";

import { auth } from "./lib/auth";


function RequireAdmin({ children }) {
  const [status, setStatus] = useState("loading"); // loading | authed | denied
  const location = useLocation();

  

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const me = await auth.me();
        setStatus(me?.role === "admin" ? "authed" : "denied");
      } catch (_) {
        setStatus("denied");
      }
    })();
    return () => { mounted = false; };
  }, []);

  if (status === "loading") return <div style={{ padding: 16 }}>Checking admin…</div>;
  if (status === "authed") return children;
  return <Navigate to="/login" replace state={{ from: location.pathname }} />;
}

export default function App() {
  return (
    <BrowserRouter>
      <Nav />
      <Routes>
        <Route path="/" element={<Calculator />} />
        <Route path="/login" element={<Login />} />
        <Route path="/admin" element={<RequireAdmin><AdminLeads /></RequireAdmin>} />
        <Route path="/admin/pricing" element={<RequireAdmin><AdminPricing /></RequireAdmin>} />
      </Routes>
    </BrowserRouter>
  );
}